import { ReduxStore } from 'store/types';

function removeWorkerIsLoading(state: ReduxStore): boolean {
  return state.intervention.removeWorker.config.isLoading;
}

export default removeWorkerIsLoading;
